import { Outlet } from "react-router-dom";
import { Header } from "components/header";

export function Layout() {
  return (
    <>
      <div className="container">
        <header>
          <Header />
        </header>
        <main>
          <Outlet />
        </main>
        <footer></footer>
      </div>
    </>
  );
}
